// 时间安排

import { RootObject, Content4 } from '../../type';

import './style.less';

const TimeArrangement = (props: RootObject["timeArrangement"]) => {
    const {
        bFrameImf,
        zhTitle,
        enTitle,
        titleImg,
        title,
        content
    } = props;
    // 如果2023年7月15日在2023年7月1日至2023年31日之间，输出true
    const isDateInRange = (startDate: string, endDate: string, checkDate: string) => {
        var start = new Date(startDate);
        var end = new Date(endDate);
        var check = new Date(checkDate);

        if (check >= start && check <= end) {
            return true;
        } else {
            return false;
        }
    };
    const getCurrentTime = () => {
        const date = new Date();
        const month = date.getMonth() + 1;
        const day = date.getDate();
        return `${month > 9 ? month : `0${month}`}.${day > 9 ? day : `0${day}`}`;
    };
    const getStatus = (time: string) => {
        return isDateInRange(time.split('—')[0], time.split('—')[1], getCurrentTime()) ? true : false;
    }


    return (
        <div className='p-p-foundathon-timeArrangement'>
            <div className='p-p-foundathon-timeArrangement-zh-title'>
                {
                    zhTitle ?? ''
                }
            </div>
            <div className='p-p-foundathon-timeArrangement-en-title'>
                {
                    enTitle ?? ''
                }
            </div>
            <div className='p-p-foundathon-timeArrangement-content' style={{ background: `url(${bFrameImf})` }}>
                <div className='p-p-foundathon-timeArrangement-content-title' style={{ background: `url(${titleImg})` }}>
                    {
                        title ?? ''
                    }
                </div>
                {/* 时间轴 */}
                <div className='p-p-foundathon-timeArrangement-content-title-time-line'>
                    {content?.map((value: Content4, index: number) => {
                        return (
                            <div className="bottom-li" key={index}>
                                <div className="li-content">
                                    <div className="li-content-time">{value.time ?? ''}</div>
                                    <div className="li-content-mark">
                                        <div className="mark-wrapper">

                                            {
                                                getStatus(value.time) ?
                                                    <div className="mark-back"></div>
                                                    :
                                                    null
                                            }
                                            <div className="mark-round"></div>
                                        </div>
                                        <div className="li-line"></div>
                                    </div>
                                    <div className="li-content-desc">
                                        <div className='li-content-desc-title'>{value.timeContent.title ?? ''}</div>
                                        <div className='li-content-desc-txt'>{value.timeContent.desc ?? ''}</div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className='p-p-foundathon-timeArrangement-back'>

            </div>
        </div>
    );
};

export default TimeArrangement;
